import { Table } from "react-bootstrap";
import ModalGlobal from '../../../../components/AppModal/ModalGlobal';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { RouteNavigationService } from "../../../../utils/navegation/RouteNavegationService";
import AppTablePagination from "../../../../components/AppTable/AppTablePagination";
import { ClientRow } from "./ClientRow";
import { ClientListFields, ClientsActions, PaginationClient } from "../types";
import { UseGetCampaingsObjectResult } from "../../campaign/types";
import { useModal } from "../../../../hooks/useModal";
import { useState } from "react";
import { DeleteReasonDto } from "../../../../types/DeleteReasonDto";
import { useUserPermissions } from "../../../../utils/auth";

interface ClientsTableProps {
    clientsData: PaginationClient;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    clientsActions: ClientsActions;
}

export default function ClientsTable({ clientsData, totalPages, currentPage, pageSize, clientsActions }: ClientsTableProps) {

    //basic imports
    const { t } = useTranslation(['client','common']);
    const navigate = useNavigate();
    const navigationService = new RouteNavigationService(navigate);
    const permissions = useUserPermissions();

    //headers
    const CLIENT_TABLE_HEADERS = {
        id: t("client:headerTableClientId"),
        clientName: t("client:headerTableClientName"),
        cif: t("client:headerTableClientCif"),
        dateRegistered: t("client:headerTableClientDateRegistered"),
        actions: t("common:actions")
    };

    const CLIENT_MODAL_HEADERS = {
        titleDelete: t("participant:modal.participantModalHeaderDelete1"),
        subtitleDelete: t("participant:modal.participantModalHeaderDelete2"),
    };

    //modal
    const { showModal, modalData, errorModal, endDate, openModal: openDeleteModal, closeModal, setLoading, setErrorModal, isLoading, currentId } = useModal<ClientListFields>();

    //handles actions
    const handleDelete = async (client: ClientListFields) => {

        const subtitle2 = "";

        openDeleteModal(
            client,
            CLIENT_MODAL_HEADERS.titleDelete,
            `${CLIENT_MODAL_HEADERS.subtitleDelete} ${client.name}?`,
            "delete",
            subtitle2
        );
    };

    const handleViewClient = (id: number) => {
        clientsActions.onView(id);
    };

    //Motive delete
    const [motiveDelete, setMotiveDelete] = useState<string>("");

    const handleMotiveDeleteChange = async (value: string | null) => {
        setMotiveDelete(value ?? "");
    }

    //handle send modal
    const handleSaveModal = async () => {

        setLoading(true); // Iniciar loading

        try {
            if (modalData.type === 'delete') {
                if (!motiveDelete.trim()) {
                    setErrorModal({ errorModal: t("common:form.requiredFieldForm") });
                    return;
                }

                const clientDeleteDto: DeleteReasonDto = {
                    deleteReason: motiveDelete
                };

                await clientsActions.onDelete(currentId, clientDeleteDto);

                navigationService.navigateWithoutMessage('/admin/client');
            }
            closeModal();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false); // Finalizar loading
        }
    }


    //Export csv
    const handleExportCsv = () => {
        console.log('Export CSV clicked');
    };
    return (
        <div>
            <ModalGlobal<UseGetCampaingsObjectResult>
                show={showModal}
                onClose={closeModal}
                title={modalData.title}
                contentType={modalData.type}
                subtitle={modalData.subtitle}
                saveText={t("common:modalActionOK")}
                closeText={t("common:modalActionNOTOK")}
                error={errorModal?.endDate || errorModal?.errorModal}
                endDate={endDate}
                onSave={() => handleSaveModal()}
                handleMotiveDeleteChange={handleMotiveDeleteChange}
                isLoading={isLoading}
            />
            <Table responsive className="mt-3">
                <thead>
                    <tr>
                        {Object.values(CLIENT_TABLE_HEADERS).map((header, index) => (
                            <th key={Object.keys(CLIENT_TABLE_HEADERS)[index]} style={{ borderTop: "none", borderBottom: "1px solid black" }}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                {clientsData.items && clientsData.items.length > 0 ? (
                    <tbody>
                        {clientsData.items.map((data, index) => (
                            <ClientRow
                                key={index}
                                client={data}
                                onDelete={handleDelete}
                                onView={handleViewClient}
                                t={t}
                            />
                        ))}
                    </tbody>
                ) : (
                    <tbody>
                        <tr>
                            <td colSpan={Object.values(CLIENT_TABLE_HEADERS).length}>{t("client:nonClients")}</td>
                        </tr>
                    </tbody>
                )}
                <tfoot>
                    <AppTablePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        pageSize={pageSize}
                        totalRecords={clientsData.totalRecords}
                        showExportLink={permissions.includes("CLIENT_MANAGEMENT.EXPORT") ? true : false}
                        onExportCsv={handleExportCsv}
                        selectorType="clients"
                    />
                </tfoot>
            </Table>
        </div>
    );
}
